export const GET_CURRENTCOURSES = "GET_CURRENTCOURSES";